import * as React from 'react';
import { ListNum } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { Editor } from '@tiptap/react';

export const OrderedListButton = (props: { editor: Editor }) => {
   const editor: Editor = props.editor;

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleOrderedList().run()}
         isActive={editor.isActive('orderedList')}
         isDisabled={!editor.can().toggleOrderedList()}
         icon={<ListNum />}
         title={_js('Add a numbered list')}
         shortcut={'shift+7'}
      />
   );
};
